export namespace FooterTemplate {
  export const HTML =
    `<footer class="footer pl-sm-3 pr-sm-3">
      <div class="container">
        <div class="row">
          <div class="col-md-4 pb-5 pb-lg-0">
            <h6 class="h65 footer-header">Lorem ipsum</h6>
            <p>Dolor sit amet</p>
            <p>Aliquam erat volutpat</p>
            <p>Suspendisse id purus</p>
            <p>Tempor mi et</p>
            <p>Donec tincidunt eros</p>
            <p>Ac egestas ornare</p>
            <p>Mauris vitae purus</p>
            <p>Duis turpis ipsum</p>
            <p>Tempor mi et</p>
          </div><div class="col-md-4 pb-5 pb-lg-0">
            <h6 class="h65 footer-header">Curabitur dignissim</h6>
            <p>Dolor sit amet</p><p>Aliquam erat volutpat</p>
            <p>Suspendisse id purus</p>
            <p>Tempor mi et</p><p>Donec tincidunt eros</p
            ><p>Ac egestas ornare</p><p>Mauris vitae purus</p>
            <p>Duis turpis ipsum</p><p>Donec tincidunt eros</p>
          </div>
          <div class="col-md-4 pb-5 pb-lg-0">
            <h6 class="h65 footer-header">Morbi tincidunt </h6>
            <p>Dolor sit amet</p><p>Aliquam erat volutpat</p><p>Suspendisse id purus</p>
            <p>Tempor mi et</p><p>Donec tincidunt eros</p><p>Ac egestas ornare</p>
            <p>Mauris vitae purus</p>
            <p>Duis turpis ipsum</p>
            <p>Ac egestas ornare</p>
          </div>
        </div>
      </div>
    </footer>`;
}
